module.exports = __webpack_public_path__ + "static/media/Banner_728x90.941d13e9.jpg";